import axios from 'axios';

/**
 * @description Axios AMORC api instance.
 */
const amorcApi = axios.create({
  /* eslint no-undef: 0 */
  baseURL: process.env.AMORC_API_URL,
  auth: {
    username: process.env.AMORC_API_USERNAME,
    password: process.env.AMORC_API_PASSWORD,
  },
});

export default amorcApi;
